/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTumorBoardMembers } from 'app/entities/tumor-board-member/tumor-board-member.reducer';
import { getEntities as getTumorBoardOccurrences } from 'app/entities/tumor-board-occurrence/tumor-board-occurrence.reducer';
import { InvitationStatus } from 'app/shared/model/enumerations/invitation-status.model';
import { createEntity, getEntity, reset, updateEntity } from './tumor-board-occurrence-participant.reducer';

export const TumorBoardOccurrenceParticipantUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const tumorBoardMembers = useAppSelector(state => state.tumorBoardMember.entities);
  const tumorBoardOccurrences = useAppSelector(state => state.tumorBoardOccurrence.entities);
  const tumorBoardOccurrenceParticipantEntity = useAppSelector(state => state.tumorBoardOccurrenceParticipant.entity);
  const loading = useAppSelector(state => state.tumorBoardOccurrenceParticipant.loading);
  const updating = useAppSelector(state => state.tumorBoardOccurrenceParticipant.updating);
  const updateSuccess = useAppSelector(state => state.tumorBoardOccurrenceParticipant.updateSuccess);
  const invitationStatusValues = Object.keys(InvitationStatus);

  const handleClose = () => {
    navigate(`/tumor-board-occurrence-participant${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTumorBoardMembers({}));
    dispatch(getTumorBoardOccurrences({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...tumorBoardOccurrenceParticipantEntity,
      ...values,
      participant: tumorBoardMembers.find(it => it.id.toString() === values.participant?.toString()),
      occurrence: tumorBoardOccurrences.find(it => it.id.toString() === values.occurrence?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          invitationStatus: 'PENDING',
          ...tumorBoardOccurrenceParticipantEntity,
          participant: tumorBoardOccurrenceParticipantEntity?.participant?.id,
          occurrence: tumorBoardOccurrenceParticipantEntity?.occurrence?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.tumorBoardOccurrenceParticipant.home.createOrEditLabel"
            data-cy="TumorBoardOccurrenceParticipantCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.home.createOrEditLabel">
              Create or edit a TumorBoardOccurrenceParticipant
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tumor-board-occurrence-participant-id"
                  label={translate('tinyMedicRestApp.tumorBoardOccurrenceParticipant.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrenceParticipant.active')}
                id="tumor-board-occurrence-participant-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrenceParticipant.cursor')}
                id="tumor-board-occurrence-participant-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrenceParticipant.lastUpdated')}
                id="tumor-board-occurrence-participant-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrenceParticipant.microSec')}
                id="tumor-board-occurrence-participant-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrenceParticipant.timestampEntry')}
                id="tumor-board-occurrence-participant-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.tumorBoardOccurrenceParticipant.invitationStatus')}
                id="tumor-board-occurrence-participant-invitationStatus"
                name="invitationStatus"
                data-cy="invitationStatus"
                type="select"
              >
                {invitationStatusValues.map(invitationStatus => (
                  <option value={invitationStatus} key={invitationStatus}>
                    {translate(`tinyMedicRestApp.InvitationStatus.${invitationStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="invitationStatusLabel">
                <Translate contentKey="tinyMedicRestApp.tumorBoardOccurrenceParticipant.help.invitationStatus" />
              </UncontrolledTooltip>
              <ValidatedField
                id="tumor-board-occurrence-participant-participant"
                name="participant"
                data-cy="participant"
                label={translate('tinyMedicRestApp.tumorBoardOccurrenceParticipant.participant')}
                type="select"
              >
                <option value="" key="0" />
                {tumorBoardMembers
                  ? tumorBoardMembers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="tumor-board-occurrence-participant-occurrence"
                name="occurrence"
                data-cy="occurrence"
                label={translate('tinyMedicRestApp.tumorBoardOccurrenceParticipant.occurrence')}
                type="select"
              >
                <option value="" key="0" />
                {tumorBoardOccurrences
                  ? tumorBoardOccurrences.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/tumor-board-occurrence-participant"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TumorBoardOccurrenceParticipantUpdate;
